<template>
	
	<CommonLoading
		v-if="loading"
	/>
	<FilterComponent
		:title="'Rotas'"
		:open="openFilter"
		:fields="filterFields"
		:activeFilters= "filters"
		@apply-filters="handleFilters"
		@update-open="openFilter = false"
	/>
	<GerenciamentoRotasMaps/>

</template>
<script>

import { pageVariables } from '@/views/insideviews/gerenciamento_rotas/PageVariablesListaDeAgendamentos';
import { handleUnauthorized } from '@/services/AuthSer/authServiceFunction';
import ListaDeAgendamentosRepository from '@/services/ListaDeAgendamentosRepository.vue';
import FilterComponent from "@/components/generalcomponents/CommonFilter.vue";
import CommonLoading from '@/components/generalcomponents/CommonLoading';
import Swal from "sweetalert2";
import GruposRepository from '@/services/GruposRepository.vue';
import GerenciamentoRotasMaps from './GerenciamentoRotasMaps.vue';

export default {
	name: 'ListaDeAgendamentosView',
	async created(){
		this.onlineUser = JSON.parse(window.localStorage.getItem("myUser") || "{}");
		this.pageData(this.getPageLista)
	},
	data() {
		return {
			...pageVariables,
			data: [],
			previous: '',
			next: '',
			totalPages: 0,
			totalRecords: 0,
			currentPage: 0,
			loading : false, 
			resetFormData: false,
			editFormData:{},
			editingOpen: false,
			viewOpen: false,
			listaData:{},
			onlineUser: JSON.parse(window.localStorage.getItem("myUser")),
			openFilter: false,
			filters: [],
			actualPage: '',
			filterFields: [
				{
					name: "consultor_email",
					label: "Consultor",
					type: "input",
					placeholder: "Digite o email do consultor"
				},
				{
					name: "endereco",
					label: "Endereço",
					type: "input",
					placeholder: "Digite o endereço"
				},
				{
					name: "data_agendamento",
					label: "Data de Contato",
					type: "date",
					placeholder: "Selecione a data de contato"
				},
				{
					name: "data_retorno",
					label: "Data de Retorno",
					type: "date",
					placeholder: "Selecione a data de retorno"
				},
				{
					name: "data_visita",
					label: "Data de Visita",
					type: "date",
					placeholder: "Selecione a data de visita"
				},
				{
					name: "status",
					label: "Status",
					type: "input",
					placeholder: "Digite o status"
				},
				{
					name: "status_contato",
					label: "Status do Atendimento",
					type: "input",
					placeholder: "Digite o status do atendimento"
				},
				{
					name: "nome",
					label: "Nome",
					type: "input",
					placeholder: "Digite o nome do segurado ou dependente"
				},
				{
					name: "idade",
					label: "Idade",
					type: "input",
					placeholder: "Digite a idade do segurado ou dependente"
				},
				{
					name: "agendamento",
					label: "Agendamento",
					type: "input",
					placeholder: "Digite o nome do agendamento"
				}
			]
		};
	},
	props: {
	},
	methods: {
		async pageData(page){
			this.actualPage = page;
			this.loading = true; 
			const listaRepo = new ListaDeAgendamentosRepository();
			try {
				const response = await listaRepo.getListas(page,this.onlineUser.token,this.filters);
				if (response?.status  === 200) {
					this.data = response.data.data;
					this.totalPages = response.data.last_page;
					this.totalRecords = response.data.total;
					this.currentPage = response.data.current_page;
					this.getConsultores()
				if (response.data.next_page_url) {
					this.next = response.data.next_page_url;
				}else{
					this.next = ""
				}
				if (response.data.prev_page_url) {

					this.previous = response.data.prev_page_url;
				}else{
					this.previous = ""
				}
				this.loading = false; 

				}
			} catch (error) {
				this.loading = false; 
				handleUnauthorized(error);
			}
		},
		async onSendFormData(data){
			this.loading = true; 
			const listaRepo = new ListaDeAgendamentosRepository();
			try {
				const response = await listaRepo.createLista(this.page,data,this.onlineUser.token);
				if (response?.status === 201) {
					this.pageData(this.actualPage);
					this.resetForm();
					this.mostrarAlerta();
				} else {
					this.error = response?.message;
				}
			} catch (error) {
				handleUnauthorized(error);
			}	
		},
		async onSendEditingData(data, id) {
			this.loading = true; 
			console.log("Data:", JSON.stringify(data, null, 2)); // Exibe o objeto formatado
			console.log("ID:", id)
			this.loading = true; 
			const listaRepo = new ListaDeAgendamentosRepository();

			try {
				const response = await listaRepo.updateLista(this.page, this.onlineUser.token, id, data);
				if (response?.status === 200) {
					this.editingOpen = false;
					this.pageData(this.getPageLista);
					this.mostrarAlerta();
					this.loading = false; 
				} else {
					this.loading = false; 
					this.error = response?.message;
				}
			} catch (error) {
				this.loading = false; 
				handleUnauthorized(error);
			}
		},
		async deleteData(id){
			const listaRepo = new ListaDeAgendamentosRepository();
			try {
				const response = await listaRepo.deleteLista(this.page,this.onlineUser.token,id);
				if (response?.status === 204) {
					this.pageData(this.getPageLista);
					this.mostrarAlerta();

				} else {
					this.error = response?.message;
				}
			} catch (error) {
				handleUnauthorized(error);
			}	
		},
		async getEditData(id){
			const listaRepo = new ListaDeAgendamentosRepository();
			try {
				const response = await listaRepo.getLista(this.page,this.onlineUser.token,id);
				if (response?.status === 200) {
					this.editFormData = response.data.agendamento
					this.editingOpen =true
				} else {
					this.error = response?.message;
				}
			} catch (error) {
				handleUnauthorized(error);
			}	
		},
		async viewData(id){
			const listaRepo = new ListaDeAgendamentosRepository();
			try {
				const response = await listaRepo.getLista(this.listaViewPage,this.onlineUser.token,id);
				if (response?.status === 200) {
					this.listaData = response.data
					this.viewOpen = true
				} else {
					this.error = response?.message;
				}
			} catch (error) {
				handleUnauthorized(error);
			}	
		},
		async getConsultores(){
			const groupsRepo = new GruposRepository();
			try {
				const response = await groupsRepo.getGroupMembers(this.onlineUser.token,this.consultoresPage);
				if (response?.status === 200) {
					this.consultores = response.data
				} else {
					this.error = response?.message;
				}
			} catch (error) {
				handleUnauthorized(error);
			}	
		},
		goTo(number){
			this.pageData(this.getPageLista+"?page="+number)
		},
		handleFilters(rawFilters){
			this.filters = rawFilters;
			this.openFilter = false;
			this.pageData(this.getPageLista);
		},
		resetForm() {
			this.resetFormData = true;
			this.$nextTick(() => {
				this.resetFormData = false;
			});
		},
		dayFilter(dateFilter){
			this.filters = { ...this.filters, data_visita: dateFilter };
			this.pageData(this.getPageLista);
		},
		mostrarAlerta() {
			Swal.fire({
				icon: 'success',
				title: 'Sucesso!',
				text: 'A operação foi concluída com sucesso.',
				confirmButtonColor: '#3085d6',
			});
		},
	},
	components:{
		FilterComponent,
		CommonLoading,
		GerenciamentoRotasMaps
	},
	setup() {
	return {
	}
	}}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
